@let class = `${className} no-data`;

<div [class]="class">
  @if (image) {
    <img [src]="image" />
  }
  {{ text | translate }}
</div>
